import { cilFile } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CRow,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchSetting } from "src/api/common";
import {
  getPendingSupportingDocbyid,
  uploadPendingDocsbyCustomer,
} from "src/api/commonapi";
import { Routes } from "src/constants/api_url";
import { notification } from "src/constants/message";
import CustomImage from "src/views/CommonFunctions/CustomImage";

const PendingSupportingDocForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get("code");
  const [submitResponse, setSubmitResponse] = useState(0);
  const [signature, setSignature] = useState("");
  const [step, setStep] = useState(0);
  const [c_url, setC_url] = useState({});
  const [docData, setDocData] = useState([]);
  const [files, setFiles] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);
  const [previewType, setPreviewType] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [data, setData] = useState("");

  useEffect(async () => {
    const resp = await fetchSetting();
    setC_url(resp?.c_url);
  }, []);

  useEffect(async () => {
    const plain = Buffer.from(code, "base64").toString("utf8");

    let resp = await getPendingSupportingDocbyid(
      parseInt(plain?.split("_")[0]),
      parseInt(plain?.split("_")[1])
    );
    if (resp?.status == 0) {
      notification({
        type: "error",
        message: resp.message,
      });
      return;
    } else {
      if (resp?.result?.length == 0) {
        setSubmitResponse(1);
      } else {
        const result = resp?.result?.flatMap((item) => {
          const docs = item.p_supporting_doc_name.split(",");
          const ids = item.p_a_supporting_doc.split(",");

          return docs.map((doc, index) => ({
            a_id: item.a_id,
            a_name: item.a_name,
            p_supporting_doc_name: doc.trim(),
            p_a_supporting_doc: ids[index] || null,
          }));
        });
        setData(resp?.result);
        // ✅ if my a_name is same but a_id is different then upload the document again
        // const uniqueDocs = Object.values(
        //   result.reduce((acc, item) => {
        //     const key = `${item.a_id}_${item.p_supporting_doc_name}`;

        //     if (!acc[key]) {
        //       acc[key] = item;
        //     }

        //     return acc;
        //   }, {})
        // );

        //✅ if my a_name is same but a_id is different I don't want to upload the document again
        const uniqueDocs = Object.values(
          result.reduce((acc, item) => {
            const key = `${item.a_name}_${item.p_supporting_doc_name}`;

            if (!acc[key]) {
              acc[key] = item;
            }

            return acc;
          }, {})
        );

        // ✅ Group by applicant
        const groupedDocs = Object.values(
          uniqueDocs.reduce((acc, item) => {
            if (!acc[item.a_id]) {
              acc[item.a_id] = {
                a_id: item.a_id,
                a_name: item.a_name,
                docs: [],
              };
            }

            acc[item.a_id].docs.push(item);

            return acc;
          }, {})
        );

        setDocData(groupedDocs);
      }
    }
  }, []);

  const uploadAllSupportingDoc = async () => {
    let fdata = new FormData();
    const totalDocs = docData.reduce(
      (sum, applicant) => sum + applicant.docs.length,
      0
    );
    const uploadedFiles = Object.keys(files).length;
    if (uploadedFiles === 0 || uploadedFiles !== totalDocs) {
      let notify = notification({
        type: "error",
        message: "Please Upload all Documents",
      });
      notify();
      return;
    } else {
      setStep(1);
      Object.keys(files).forEach((key) => {
        fdata.append("files", files[key].file);
      });
      const plain = Buffer.from(code, "base64").toString("utf8");
      fdata.append("c_id", plain?.split("_")[0]);
      fdata.append("c_s_type", plain?.split("_")[1]);
      fdata.append("data", JSON.stringify(data));

      const resp = await uploadPendingDocsbyCustomer(fdata);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message,
      });
      notify();
      if (resp.status == 1) {
        setSignature(resp?.data);
        setSubmitResponse(1);
        setData("");
        setFiles([]);
        setDocData([]);
      }
      setStep(0);
    }
  };

  return (
    <>
      <div className="d-flex flex-row">
        <CContainer>
          {submitResponse == 0 ? (
            <>
              <div className="center-hor-ver">
                <div className="form-container-cus bg-white my-5">
                  <CRow>
                    <CCol md={12} className="text-center m-1">
                      <CustomImage
                        src={`${Routes.API_HOSTNAME}/images/adminlogo/loginlogo.png`}
                        className="cus_form_logo"
                      />
                      <h5
                        className="form_title text-center"
                        style={{ color: "black" }}
                      >
                        Click the Submit button after uploading all documents
                      </h5>
                    </CCol>
                    <CCol>
                      <CForm className="mt-3 px-2">
                        {docData?.map((applicant, aIndex) => (
                          <div key={applicant.a_id}>
                            {/* Applicant Name */}
                            <CRow className="my-2">
                              <CCol md={12}>
                                <CFormLabel
                                  className="mb-1 d-flex justify-content-center"
                                  style={{
                                    color: "black",
                                    backgroundColor: "#bbdbf5",
                                    border: "1px solid black",
                                    padding: "5px",
                                    borderRadius: "5px",
                                  }}
                                >
                                  Applicant Name : {applicant.a_name}
                                </CFormLabel>
                              </CCol>
                            </CRow>

                            {/* Documents */}
                            {applicant.docs.map((doc, index) => {
                              const fileIndex = `${aIndex}_${index}`;

                              return (
                                <CRow key={fileIndex} className="my-2">
                                  <CCol md={12}>
                                    <CFormLabel style={{ color: "black" }}>
                                      <b>Document Name :</b>{" "}
                                      {doc.p_supporting_doc_name}
                                    </CFormLabel>

                                    <CFormInput
                                      type="file"
                                      accept="image/*,application/pdf"
                                      onChange={(event) => {
                                        const selectedFile =
                                          event.target.files[0];

                                        if (selectedFile) {
                                          // 5 MB limit
                                          const maxSize = 5 * 1024 * 1024;

                                          if (selectedFile.size > maxSize) {
                                            notification({
                                              type: "error",
                                              message:
                                                "File size should not exceed 5 MB",
                                            })();

                                            // reset input
                                            event.target.value = "";
                                            return;
                                          }

                                          const fileData = {
                                            file: selectedFile,
                                            url: URL.createObjectURL(
                                              selectedFile
                                            ),
                                            type: selectedFile.type,
                                            name: selectedFile.name,
                                          };

                                          const key = `${aIndex}_${index}`;

                                          setFiles((prev) => ({
                                            ...prev,
                                            [key]: fileData,
                                          }));
                                        }
                                      }}
                                    />
                                  </CCol>

                                  <CCol md={12}>
                                    {files[fileIndex] && (
                                      <>
                                        <span
                                          style={{
                                            color: "#0d6efd",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            marginRight: "10px",
                                          }}
                                          onClick={() => {
                                            setPreviewFile(
                                              files[fileIndex].url
                                            );
                                            setPreviewType(
                                              files[fileIndex].type
                                            );
                                            setShowPreview(true);
                                          }}
                                        >
                                          {files[fileIndex].name}
                                        </span>

                                        <span
                                          style={{
                                            color: "red",
                                            cursor: "pointer",
                                            fontWeight: "bold",
                                          }}
                                          onClick={() => {
                                            setFiles((prev) => {
                                              const updated = { ...prev };
                                              delete updated[fileIndex];
                                              return updated;
                                            });
                                          }}
                                        >
                                          ❌
                                        </span>
                                      </>
                                    )}
                                  </CCol>
                                </CRow>
                              );
                            })}

                            <hr />
                          </div>
                        ))}

                        <CCol className="my-3" style={{ textAlign: "center" }}>
                          <CButton
                            disabled={step == 0 ? false : true}
                            color="primary"
                            onClick={() => {
                              uploadAllSupportingDoc();
                            }}
                          >
                            Submit
                          </CButton>
                        </CCol>
                      </CForm>
                    </CCol>
                  </CRow>
                </div>
              </div>
            </>
          ) : (
            <>
              <CRow className="justify-content-center">
                <CCol md={5} style={{ width: "600px" }}>
                  <CCardGroup>
                    <CCard className="p-4">
                      <CCardBody>
                        <>
                          <CForm className="dsgrid">
                            <CustomImage
                              src={`${Routes.API_HOSTNAME}/images/adminlogo/check.png`}
                              className="mb-3 center_img"
                            />
                            <h5
                              className="text-center mb-3"
                              style={{ color: "#000" }}
                            >
                              Your all Documents are already uploded
                            </h5>

                            <h2
                              className="text-center mb-3"
                              style={{ color: "#000" }}
                            >
                              Thank You
                            </h2>
                            {signature != "" && (
                              <h5
                                className="text-center mb-3"
                                style={{ color: "#000" }}
                              >
                                {signature}
                              </h5>
                            )}
                          </CForm>
                        </>
                      </CCardBody>
                    </CCard>
                  </CCardGroup>
                </CCol>
              </CRow>
            </>
          )}
        </CContainer>
      </div>
      <CModal
        visible={showPreview}
        onClose={() => setShowPreview(false)}
        size="lg"
      >
        <CModalHeader>
          <CModalTitle>Document Preview</CModalTitle>
        </CModalHeader>

        <CModalBody className="text-center">
          {previewType === "application/pdf" ? (
            <iframe
              src={previewFile}
              title="PDF Preview"
              width="100%"
              height="500px"
            />
          ) : (
            <img
              src={previewFile}
              alt="preview"
              style={{ maxWidth: "100%", maxHeight: "500px" }}
            />
          )}
        </CModalBody>
      </CModal>
    </>
  );
};

export default PendingSupportingDocForm;
